export default __webpack_public_path__ + "static/media/mystryverse_new.4852c9c0.mp4";